import React from 'react';
import { Col, Icon } from 'antd';
import moment from 'moment';
import {
  DataValue,
  DataValueMobile,
  DataHeadingMobile,
  UnderlineLinkTxn,
  DataDescription,
  DashboardDivider,
} from './styles';
import recurringIcon from '../../../../assets/icons/recurring.svg';
import {
  formatShares,
  checkForFreezeFunctionality,
  formatAmount,
  formatSharesWithSixDecimal,
} from '../../../../utils/commonUtil';
import { TransactionName, DataHeading } from '../../../../CommonComponents/commonStyles';
const FLOW_CHECKER = 'MAC';

export function disabledValidator(accData) {
  return checkForFreezeFunctionality().indexOf(FLOW_CHECKER) !== -1
    ? true
    : false || accData.roleAccess === 'Read Only'
    ? true
    : false;
}

export function disabledText(accData) {
  return checkForFreezeFunctionality().indexOf(FLOW_CHECKER) !== -1
    ? 'Transactions for this account are frozen. Contact us at 888-383-4483 or donorservice@vanguardcharitable.org'
    : '' || accData.roleAccess === 'Read Only'
    ? 'You are unable to make contributions on this account. If you believe this is an error, please contact us at 888-383-4483.'
    : '';
}

export function renderContributionTitleGrid({
  data,
  each,
  label,
  index,
  linkUrl,
  comingSoon,
  handleTitleClick,
}) {
  return (
    <Col lg={24} md={24} className={index !== 0 ? 'mt-xs-invest20' : 'mt0'}>
      {comingSoon ? (
        <span className='tool-tip'>
          <UnderlineLinkTxn>
            {label}: {data[each]}
            {data.pendingContribution === true ? (
              <img
                src={recurringIcon}
                className='cursor-auto ml2'
                alt='pending-transactions'
              />
            ) : (
              <div />
            )}
          </UnderlineLinkTxn>
          <span>
            <span className='tooltiptext-i'>Coming Soon...</span>
          </span>
        </span>
      ) : (
        <UnderlineLinkTxn
          reversed={data.reversed}
          onClick={data.reversed ? null : handleTitleClick}
        >
          {label}: {data[each]}
          <span className='tool-tip'>
            <span className='alert-icon'>
              <Icon
                className={data.pendingContribution === false ? 'hide' : 'show'}
                type='warning'
              />
            </span>
            <span>
              <span class='tooltiptext-i'>
                This pending transaction requires attention
              </span>
            </span>
          </span>
        </UnderlineLinkTxn>
      )}
    </Col>
  );
}

export function renderDashboardTypeFixGrid({ data, each, label, mtop }) {
  return (
    <Col
      lg={8}
      md={24}
      className={mtop === true ? 'mt1 tab-fix' : 'mt0 tab-fix'}
    >
      <DataHeading className='mt-20'>{label}</DataHeading>
      {data[each] === '' || data[each] === null ? (
        <DataValue dashboard> &mdash; </DataValue>
      ) : (
        <DataValue className='mt0' dashboard>
          {data[each] === 'VBS Security' ? 'VBS Security' : data[each]}
        </DataValue>
      )}
    </Col>
  );
}

export function renderContributionNameGrid({ data, label, index }) {
  return (
    <>
      <Col lg={24} md={24} className={index !== 0 ? 'mt-xs-invest20' : 'mt0'}>
        <TransactionName>
          {label}:{' '}
          <b>
            {`${data['dpUserPrefix'] ? data['dpUserPrefix'] : ''}${
              data['dpUserFirstName'] ? ' ' + data['dpUserFirstName'] : ''
            }${data['dpUserMiddleName'] ? ' ' + data['dpUserMiddleName'] : ''}${
              data['dpUserLastName'] ? ' ' + data['dpUserLastName'] : ''
            }${data['dpUserSuffix'] ? ', ' + data['dpUserSuffix'] : ''}`}
          </b>
        </TransactionName>
        {data.isRecurring === 'true' ? (
          <img
            src={recurringIcon}
            className='cursor-auto ml2'
            alt='recurring-transaction'
          />
        ) : (
          <div />
        )}
      </Col>
    </>
  );
}

export function renderDescriptionGrid({ index }) {
  return (
    <Col lg={24} md={24} className={index !== 0 ? 'mt-xs-invest20' : 'mt0'}>
      <DataDescription>
        Vanguard New Jersey Long-Term Tax-Exempt Fund Admiral Shares
      </DataDescription>
    </Col>
  );
}

export function renderTypeFixGrid({ data, each, label, mtop }) {
  return (
    <Col lg={8} md={24} className={mtop === true ? 'mt1' : 'mt0'}>
      <DataHeading className='mt-20'>{label}</DataHeading>
      {data[each] === '' || data[each] === null ? (
        <DataValue> &mdash; </DataValue>
      ) : (
        <DataValue className='mt0'>
          {data[each] === 'VBS Security'
            ? 'VBS Security'
            : typeof data[each] === 'string'}
        </DataValue>
      )}
    </Col>
  );
}

export function renderUserNameFixGrid({ data, label, mtop }) {
  return (
    <Col
      lg={8}
      md={24}
      className={mtop === true ? 'mt1 tab-fix' : 'mt0 tab-fix'}
    >
      <DataHeading className='mt-20'>{label}</DataHeading>
      {data['dpUserFirstName'] === '' || data['dpUserFirstName'] === null ? (
        <DataValue dashboard> &mdash; </DataValue>
      ) : (
        <DataValue className='mt0' dashboard>
          {`${data['dpUserPrefix'] ? data['dpUserPrefix'] : ''}${
            data['dpUserFirstName'] ? ' ' + data['dpUserFirstName'] : ''
          }${data['dpUserMiddleName'] ? ' ' + data['dpUserMiddleName'] : ''}${
            data['dpUserLastName'] ? ', ' + data['dpUserLastName'] : ''
          }${data['dpUserSuffix'] ? ' ' + data['dpUserSuffix'] : ''}`}
        </DataValue>
      )}
    </Col>
  );
}

export function renderContributionDateGrid({ data, each, label, mtop }) {
  return (
    <>
      <Col lg={8} md={12} xs={0} className={mtop === true ? 'mt1' : 'mt0'}>
        <DataHeading className='mt-20'>{label}</DataHeading>
        {data[each] !== null ? (
          <DataValue className='mt0' dashboard>
            {moment(moment.tz(data[each], 'America/New_York')).format('L')}
          </DataValue>
        ) : (
          <DataValue> &mdash; </DataValue>
        )}
      </Col>
      <Col lg={0} md={0} xs={12} className={mtop === true ? 'mt1' : 'mt0'}>
        <DataHeading className='mt-20'>{label}</DataHeading>
        {data[each] !== null ? (
          <DataValue className='mt0' dashboard>
            {moment(moment.tz(data[each], 'America/New_York')).format('L')}
          </DataValue>
        ) : (
          <DataValue> &mdash; </DataValue>
        )}
        <DashboardDivider />
      </Col>
    </>
  );
}

export function renderAmountGrid({ data, each, label, mtop }) {
  return (
    <Col lg={8} md={12} className={mtop === true ? 'mt1' : 'mt0'}>
      <DataHeading className='mt-20'>{label}</DataHeading>
      {data[each] !== null ? (
        <DataValue className='mt0'>
          {'$' +
            Number(data[each]).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
        </DataValue>
      ) : (
        <DataValue> &mdash; </DataValue>
      )}
    </Col>
  );
}

export function renderContributionFixGrid({ data, each, label, mtop }) {
  let getResult = (each, data) => {
    if (each === 'amount') {
      return formatAmount(data[each]);
    } else if (typeof data[each] == 'string') {
      return (
        data[each].charAt(0).toUpperCase() + data[each].slice(1).toLowerCase()
      );
    } else if (each === 'noOfShares') {
      return data.type === 'Special Asset'
        ? formatSharesWithSixDecimal(data[each])
        : formatShares(data[each]);
    } else {
      return data[each];
    }
  };
  return (
    <>
      <Col lg={8} md={12} xs={0} className={mtop === true ? 'mt1' : 'mt0'}>
        <DataHeading className='mt-20'>{label}</DataHeading>
        {data[each] === '' || data[each] === null ? (
          <DataValue dashboard> &mdash; </DataValue>
        ) : (
          <DataValue dashboard className='mt0'>
            {getResult(each, data)}
          </DataValue>
        )}
      </Col>
      <Col lg={0} md={0} xs={label === 'User Name' ? 24 : 12}>
        {label === 'User Name' ? (
          <DataHeadingMobile className='mt-20'>{label}</DataHeadingMobile>
        ) : (
          <DataHeading className='mt-20'>{label}</DataHeading>
        )}
        {data[each] === '' || data[each] === null ? (
          label === 'User Name' ? (
            <DataValueMobile> &mdash; </DataValueMobile>
          ) : (
            <DataValue> &mdash; </DataValue>
          )
        ) : label === 'User Name' ? (
          <DataValueMobile>
            {each === 'status.extDescription'
              ? data.status.extDescription
              : data[each] === 'SHARE'
              ? 'Units'
              : typeof data[each] == 'string'
              ? data[each].charAt(0).toUpperCase() +
                data[each].slice(1).toLowerCase()
              : data[each]}
          </DataValueMobile>
        ) : (
          <DataValue className='mt0'>
            {each === 'status.extDescription'
              ? data.status.extDescription
              : data[each] === 'SHARE'
              ? 'Units'
              : typeof data[each] === 'string'
              ? data[each].charAt(0).toUpperCase() +
                data[each].slice(1).toLowerCase()
              : data[each]}
          </DataValue>
        )}
        <DashboardDivider />
      </Col>
    </>
  );
}

export function renderShareFixGrid({ data, each, label, mtop }) {
  return (
    <Col
      lg={8}
      md={24}
      className={mtop === true ? 'mt1 tab-fix' : 'mt0 tab-fix'}
    >
      <DataHeading className='mt-20'>{label}</DataHeading>
      {data[each] === '' ||
      data[each] === null ||
      (data.type === 'Special Asset' && data[each] === 0) ? (
        <DataValue dashboard> &mdash; </DataValue>
      ) : (
        <DataValue className='mt0' dashboard>
          {data['allShares'] === true
            ? 'All Shares'
            : data.type === 'Special Asset'
            ? formatSharesWithSixDecimal(data[each])
            : formatShares(data[each])}
        </DataValue>
      )}
    </Col>
  );
}

export function renderContributionsSettledDateGrid({
  data,
  each,
  label,
  mtop,
}) {
  return data[each] !== null ? (
    <Col
      lg={8}
      md={12}
      className={mtop === true ? 'mt1 tab-fix' : 'mt0 tab-fix'}
    >
      <DataHeading className='mt-20'>{label}</DataHeading>
      <DataValue className='mt0'>
        {moment.tz(moment(data[each]), 'America/New_York').format('L')}
      </DataValue>
    </Col>
  ) : null;
}
